// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media screen and (max-width: 3840px) {
    .lifePathBarChart{
        width: 50% !important; 
        min-width: 500px !important;
        height: 400px !important;
        transform: translateX(-3%);
    }

    .lifePathBarChartTitle{
        font-size: 30px;
        margin-top: 50px;
    }

    .pieChartSection{
        display:flex;
        justify-content: center;
        height: 500px !important;
    }

    .pieChartContainer{
        display:flex;
        flex-direction: column;
        align-items: center;
        height: 500px !important;
    }

    .pieChart{
        width: 100% !important; 
        min-width: 300px !important;
    }

    .pieChartTitle{
        transform: translateY(100px);
    }

    .premiumGroup1{
        display:flex;
        flex-direction: column;
        width: 40%;
        min-width: 400px;
    }

    .premiumGroup1-title{
        font-weight: bold;
        font-size: 30px;
    }

    .premiumGroup1-number{
        font-weight: 600;
        margin-left: 10px;
    }

    .premiumGroup1 ul li{
        display: flex;
    }

    .premiumGroup1-click{
        color: blue;
        margin-left: 20px;
        cursor: pointer;
    }

    .premiumGroup1 .btn{
        width: 150px;
        align-self: center;
        font-weight: 500;
    }

    .premiumGroup1 .btn:hover{
        background-color: #ffae00;
    }
    
    .health-ul{
        max-width: 700px;
        list-style: none;
        margin-bottom: 50px;
    }

}


@media screen and (max-width: 540px) {
    .lifePathBarChart{
        width: 100% !important; 
        min-width: auto !important;
        height: 300px !important;
        transform: translateX(-5%);
    }

    .premiumGroup1{
        width: 100%;
        min-width: auto;
    }

    .premiumGroup1-title{
        font-weight: bold;
        font-size: 24px;
    }

    .pieChartSection{
        display:flex;
        flex-direction: column;
        justify-content: center;
        width: 100% !important; 
        height: 500px !important;
    }

    .pieChartContainer{
        display:flex;
        flex-direction: column;
        align-items: center;
        height: 250px !important;
    }

    .health-ul{
        box-sizing: border-box;
        max-width: 500px;
        list-style: none;
        margin-bottom: 50px;
        padding: 10px 10px
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/Premium.css"],"names":[],"mappings":"AAAA;IACI;QACI,qBAAqB;QACrB,2BAA2B;QAC3B,wBAAwB;QACxB,0BAA0B;IAC9B;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,YAAY;QACZ,uBAAuB;QACvB,wBAAwB;IAC5B;;IAEA;QACI,YAAY;QACZ,sBAAsB;QACtB,mBAAmB;QACnB,wBAAwB;IAC5B;;IAEA;QACI,sBAAsB;QACtB,2BAA2B;IAC/B;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,YAAY;QACZ,sBAAsB;QACtB,UAAU;QACV,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;QACjB,eAAe;IACnB;;IAEA;QACI,gBAAgB;QAChB,iBAAiB;IACrB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,WAAW;QACX,iBAAiB;QACjB,eAAe;IACnB;;IAEA;QACI,YAAY;QACZ,kBAAkB;QAClB,gBAAgB;IACpB;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,gBAAgB;QAChB,gBAAgB;QAChB,mBAAmB;IACvB;;AAEJ;;;AAGA;IACI;QACI,sBAAsB;QACtB,0BAA0B;QAC1B,wBAAwB;QACxB,0BAA0B;IAC9B;;IAEA;QACI,WAAW;QACX,eAAe;IACnB;;IAEA;QACI,iBAAiB;QACjB,eAAe;IACnB;;IAEA;QACI,YAAY;QACZ,sBAAsB;QACtB,uBAAuB;QACvB,sBAAsB;QACtB,wBAAwB;IAC5B;;IAEA;QACI,YAAY;QACZ,sBAAsB;QACtB,mBAAmB;QACnB,wBAAwB;IAC5B;;IAEA;QACI,sBAAsB;QACtB,gBAAgB;QAChB,gBAAgB;QAChB,mBAAmB;QACnB;IACJ;AACJ","sourcesContent":["@media screen and (max-width: 3840px) {\n    .lifePathBarChart{\n        width: 50% !important; \n        min-width: 500px !important;\n        height: 400px !important;\n        transform: translateX(-3%);\n    }\n\n    .lifePathBarChartTitle{\n        font-size: 30px;\n        margin-top: 50px;\n    }\n\n    .pieChartSection{\n        display:flex;\n        justify-content: center;\n        height: 500px !important;\n    }\n\n    .pieChartContainer{\n        display:flex;\n        flex-direction: column;\n        align-items: center;\n        height: 500px !important;\n    }\n\n    .pieChart{\n        width: 100% !important; \n        min-width: 300px !important;\n    }\n\n    .pieChartTitle{\n        transform: translateY(100px);\n    }\n\n    .premiumGroup1{\n        display:flex;\n        flex-direction: column;\n        width: 40%;\n        min-width: 400px;\n    }\n\n    .premiumGroup1-title{\n        font-weight: bold;\n        font-size: 30px;\n    }\n\n    .premiumGroup1-number{\n        font-weight: 600;\n        margin-left: 10px;\n    }\n\n    .premiumGroup1 ul li{\n        display: flex;\n    }\n\n    .premiumGroup1-click{\n        color: blue;\n        margin-left: 20px;\n        cursor: pointer;\n    }\n\n    .premiumGroup1 .btn{\n        width: 150px;\n        align-self: center;\n        font-weight: 500;\n    }\n\n    .premiumGroup1 .btn:hover{\n        background-color: #ffae00;\n    }\n    \n    .health-ul{\n        max-width: 700px;\n        list-style: none;\n        margin-bottom: 50px;\n    }\n\n}\n\n\n@media screen and (max-width: 540px) {\n    .lifePathBarChart{\n        width: 100% !important; \n        min-width: auto !important;\n        height: 300px !important;\n        transform: translateX(-5%);\n    }\n\n    .premiumGroup1{\n        width: 100%;\n        min-width: auto;\n    }\n\n    .premiumGroup1-title{\n        font-weight: bold;\n        font-size: 24px;\n    }\n\n    .pieChartSection{\n        display:flex;\n        flex-direction: column;\n        justify-content: center;\n        width: 100% !important; \n        height: 500px !important;\n    }\n\n    .pieChartContainer{\n        display:flex;\n        flex-direction: column;\n        align-items: center;\n        height: 250px !important;\n    }\n\n    .health-ul{\n        box-sizing: border-box;\n        max-width: 500px;\n        list-style: none;\n        margin-bottom: 50px;\n        padding: 10px 10px\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
